var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6316 13.3805C25.6316 20.2805 20.0191 25.8805 13.1316 25.8805L12.7819 25.8757C6.04337 25.6903 0.631592 20.1635 0.631592 13.3805C0.631592 6.49299 6.23159 0.880493 13.1316 0.880493C20.0191 0.880493 25.6316 6.49299 25.6316 13.3805ZM10.6565 8.3805C10.294 8.7555 10.294 9.34299 10.669 9.70549L14.3565 13.3805L10.669 17.0555C10.294 17.418 10.294 18.018 10.6565 18.3805C11.0315 18.7555 11.619 18.7555 11.9815 18.3805L16.344 14.043C16.519 13.868 16.619 13.6305 16.619 13.3805C16.619 13.1305 16.519 12.893 16.344 12.718L11.9815 8.3805C11.8065 8.193 11.569 8.10549 11.3315 8.10549C11.0815 8.10549 10.844 8.193 10.6565 8.3805Z",
    fill: "#12233D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.e99e02a4960bb3a5f11fbfb6cdaa8086.svg";
export { ForwardRef as ReactComponent };